import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import Pill from "../../CommonComponents/Pill";
import { useNavigate } from "react-router-dom";
import { getAllCasesCount } from "../../Services/case.service";
import useToaster from "../../customHook/useToaster";
import { useSelector } from "react-redux";

export default function CaseManagementComponent({ onClick = () => {} }) {
  const [allCaseCount, setAllCaseCount] = useState({});
  const navigate = useNavigate();
  const { showToast } = useToaster();
  const userRole = useSelector(
    (state) => state?.loginSlice?.userData?.currentRoleName
  );
  const { activeTourStep } = useSelector((state) => state.appTourSlice);
  const isTourActive =
    activeTourStep === 8
      ? {
          background: "white",
          boxShadow: "0px 2px 10px 0px #FFFFFFB2",
          borderRadius: "20px",
          border: "1px solid #9F9F9F",
          padding: "8px",
        }
      : {};
  const onClickHandler = (e, tabIndex) => {
    onClick(e, tabIndex);
  };
  const createCasehandler = () => {
    return navigate("/createCase");
  };
  useEffect(() => {
    getAllCasesCount()
      .then((data) => {
        if (data.success) setAllCaseCount(data?.data);
      })
      .catch((error) => {});
  }, []);
  return (
    <Box
      sx={{
        "& > :not(style)": { m: 1 },
        ...isTourActive,
      }}
      id="dash-case-management"
    >
      <Typography
        variant="h6"
        sx={{
          fontSize: "1.7rem",
          lineHeight: "2.1rem",
          paddingBottom: "1rem",
          paddingTop: "0.5rem",
          // width:"34rem"
        }}
      >
        Case Management
      </Typography>
      <Pill
        noOfCases={allCaseCount?.open}
        caseType={"Open Cases"}
        onClick={() => onClickHandler("20 Open", 0)}
        sx={{
          color: "white",
        }}
      />
      <Pill
        noOfCases={allCaseCount?.allocated}
        caseType={"Allocated Cases"}
        onClick={() => onClickHandler("20 Allocated", 1)}
        sx={{}}
      />
      {userRole !== "QC" && (
        <Pill
          noOfCases={allCaseCount?.qc}
          caseType={"QC Cases"}
          onClick={() => onClickHandler("20 QC", 2)}
        />
      )}
      {/* <Pill
        noOfCases={allCaseCount?.query}
        caseType={"Query Cases"}
        onClick={() => onClickHandler("20 Query", 3)}
      /> */}
      <Pill
        noOfCases={allCaseCount?.recommended}
        caseType={"Recommended Cases"}
        onClick={() => onClickHandler("20 Recommended", 3)}
      />
      <Pill
        noOfCases={allCaseCount?.submitted}
        caseType={"Submitted Cases"}
        onClick={() => onClickHandler("20 Submitted", 4)}
      />

      {/* <Pill
        noOfCases={allCaseCount?.rejected}
        caseType={"Rejected Cases"}
        onClick={() => onClickHandler("20 Rejected", 5)}
      /> */}
      {userRole === "IM" && <Pill create={true} onClick={createCasehandler} />}
    </Box>
  );
}
